import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
} from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cigna-cfb-contractor-confirm-box',
  templateUrl: './contractor-confirm-box.component.html',
  styleUrls: ['./contractor-confirm-box.component.scss'],
})
export class ContractorConfirmBoxComponent implements OnInit, OnChanges {
  @Output() noClicked = new EventEmitter();
  @Output() yesClicked = new EventEmitter();
  @Output() ifpYesClicked = new EventEmitter();
  @Output() ifpNoClicked = new EventEmitter();
  @Output() maYesClicked = new EventEmitter();
  @Output() maNoClicked = new EventEmitter();
  @Input() lob: string;
  @Output() CsbYesClicked = new EventEmitter();
  @Output() CsbNoClicked = new EventEmitter();
  @Output() restartClicked = new EventEmitter();
  @Output() exitClicked = new EventEmitter();
  templateId = 'commercialConfirmTemplate';

  constructor(
    private appstateFacade: AppstateFacade,
    public dialogRef: MatDialogRef<ContractorConfirmBoxComponent>,
  ) {}

  ngOnInit() {
    this.showLobContent();
  }

  ngOnChanges() {
    this.showLobContent();
  }

  showLobContent() {
    if (this.lob === 'COMMERCIAL') {
      this.showCommercial();
    } else if (this.lob === 'IFP') {
      this.showIfp();
    } else if (this.lob === 'MA') {
      this.showMa();
    } else if (this.lob === 'CSB') {
      this.showCsb();
    } else if (this.lob === 'RESTART') {
      this.showRestart();
    }
  }

  onYesClicked() {
    this.appstateFacade.saveCommercialFlag(true);

    this.yesClicked.emit();
  }

  onNoClicked() {
    this.appstateFacade.saveCommercialFlag(false);

    this.showIfp();
    this.noClicked.emit();
  }

  showCommercial() {
    this.templateId = 'commercialConfirmTemplate';
  }

  showIfp() {
    this.templateId = 'ifpConfirmTemplate';
  }

  showMa() {
    this.templateId = 'maConfirmTemplate';
  }

  showCsb() {
    this.templateId = 'csbConfirmTemplate';
  }

  showRestart() {
    this.templateId = 'restartConfirmTemplate';
  }

  onIfpYesClicked() {
    this.appstateFacade.saveIfpFlag(true);

    this.ifpYesClicked.emit();
  }

  onIfpNoClicked() {
    this.appstateFacade.saveIfpFlag(false);

    this.showMa();
    this.ifpNoClicked.emit();
  }

  onMaYesClicked() {
    this.appstateFacade.saveMaFlag(true);

    this.maYesClicked.emit();
  }

  onMaNoClicked() {
    this.appstateFacade.saveMaFlag(false);

    this.showCsb();
    this.maNoClicked.emit();
  }
  onCsbYesClicked() {
    this.trackCSBClicks('Yes');
    this.CsbYesClicked.emit();
  }

  onCsbNoClicked() {
    this.trackCSBClicks('No');
    this.CsbNoClicked.emit();
  }

  trackCSBClicks(buttonSelected: string) {
    this.appstateFacade.sendAnalytics({
      event: 'pageAction',
      reqData: {
        requirementId: 'acONB007',
        userStory: 'MTD-3618',
        hitType: 'action',
      },
      actionData: {
        widgetName: 'csb-appointment-buttons',
        customLinkText: buttonSelected,
      },
    });
  }
}
